import React from 'react';
import { Button, message } from 'antd';
import { useParams } from 'react-router-dom';
import {
  ModalForm,
  ProFormRadio,
  ProFormText,
  ProFormDependency,
} from '@ant-design/pro-form';
import { useMutation } from '@apollo/client';
import { UPDATE_USER_AUTHENTICATION_MODE, GET_USERS } from 'gql/users';

const UpdateAuthenticationModeModalForm = () => {
  const { id } = useParams();
  const [updateUserAuthenticationMode] = useMutation(
    UPDATE_USER_AUTHENTICATION_MODE,
    {
      refetchQueries: [{ query: GET_USERS, variables: { ids: [id] } }],
    }
  );
  return (
    <ModalForm
      title="Edit Authentication Mode"
      requiredMark="optional"
      trigger={
        <Button
          type="primary"
          style={{
            marginLeft: '16px',
          }}
          size="middle"
        >
          Edit
        </Button>
      }
      onFinish={async (values) => {
        await updateUserAuthenticationMode({
          variables: {
            input: {
              id,
              authenticationMode: values.authenticationMode,
              password:
                values.authenticationMode === 'PASSWORD'
                  ? values.password
                  : null,
            },
          },
        });
        message.success('Authentication mode updated');
        return true;
      }}
    >
      <ProFormRadio.Group
        key="authenticationMode"
        name="authenticationMode"
        radioType="button"
        label="Authentication Mode"
        options={[
          {
            label: 'PolyU SSO Directory',
            value: 'DIRECTORY',
          },
          {
            label: 'Password',
            value: 'PASSWORD',
          },
        ]}
        rules={[
          {
            required: true,
          },
        ]}
      />
      <ProFormDependency name={['authenticationMode']}>
        {({ authenticationMode }) => {
          return (
            <ProFormText
              width="xl"
              name="password"
              label="Password"
              placeholder="password"
              disabled={authenticationMode !== 'PASSWORD'}
              rules={[
                {
                  required: authenticationMode === 'PASSWORD',
                },
              ]}
            />
          );
        }}
      </ProFormDependency>
    </ModalForm>
  );
};

export default UpdateAuthenticationModeModalForm;
